<div>
    <label v-if="heading !== null && heading !== ''">{{ heading }}</label>
    <div class="row">
        <div class="col-sm-6">
            <div class="form-group">
                <label>From Date</label>
                <date-picker :format="dateFormat" :elementId="elementId + '1'" :date="componentFromDate"
                             :initialiseDate="initialiseDate"
                             @dateSelected="onFromDateCreatedSelect"></date-picker>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label>To Date</label>
                <date-picker :format="dateFormat" :elementId="elementId + '2'" :date="componentToDate"
                             :initialiseDate="initialiseDatePickerEndDate"
                             @dateSelected="onToDateCreatedSelect"></date-picker>
            </div>
        </div>
        <button class="btn btn-link" @click="onDateSelectClearClick" v-show="hideClearButton !== true">Clear</button>
    </div>
</div>